<template>
    <button @click="handleClick" type="button" :class="classes" :disabled="disabled">
        <transition mode="out-in"
                    enter-active-class="animated zoomIn"
                    leave-active-class="animated zoomOut"
                    @before-leave="beforeLeave"
                    @after-enter="afterEnter"
                    appear>
            <span class="btn-state" v-if="status === 'loading'" key="loading">
                <svgicon name="refresh"/>
            </span>

            <span class="btn-state" v-else-if="status === 'failed'" key="failed">
                <svgicon name="sad-face"/>
            </span>

            <span class="btn-state" v-else-if="status === 'succeeded'" key="succeeded">
                <svgicon name="happy-face"/>
            </span>

            <span class="inline-flex" v-else key="normal">
                <svgicon :class="iconClass" v-if="icon && iconPosition === 'start'" :name="icon"/>
                <slot></slot>
                <svgicon :class="iconClass" v-if="icon && iconPosition === 'end'" :name="icon"/>
            </span>
        </transition>
    </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },

    iconPosition: {
      type: String,
      default: 'start',
    },

    iconClass: {
      type: String,
      default: null,
    },

    status: {
      type: String,
      default: null,
    },

    eventModifier: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        `btn-icon-${this.iconPosition}`,
        { 'btn-icon': this.icon && Object.keys(this.$slots).length === 0 },
        { 'is-loading': this.status === 'loading' },
        { 'has-failed': this.status === 'failed' },
        { 'has-succeeded': this.status === 'succeeded' },
      ];
    },
  },

  methods: {
    beforeLeave(el) {
      if (!el.classList.contains('btn-state')) {
        // Add width constraint to avoid the button to shrink
        this.$el.style.width = `${this.$el.getBoundingClientRect().width}px`;
      }
    },

    afterEnter(el) {
      if (!el.classList.contains('btn-state')) {
        // Once transition done remove the width constraint
        this.$el.style.width = null;
      }
    },

    handleClick(event) {
      if (this.eventModifier === 'stop') {
        event.stopPropagation();
      }

      if (this.eventModifier === 'prevent') {
        event.preventDefault();
      }

      this.$emit('click');
    },
  },
};
</script>